import {styled, TableCell} from '@mui/material'

import {TABLE_Z_INDEX, pinnedColumnShadowStyles, pinnedColumnShadowStylesLeft} from './styles'

type PinnableHeaderTableCellProps = {
  width: number
  left?: number
  right?: number
  showShadow?: boolean
  isSticky?: boolean
}

export const PinnableHeaderTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'showShadow' && prop !== 'isSticky'
})<PinnableHeaderTableCellProps>(({theme, width, left, showShadow, isSticky, right}) => ({
  width: `${width}px`,
  position: isSticky ? 'sticky' : 'relative',
  top: isSticky ? 0 : 'auto',
  left: left,
  right: right,
  // Fundamental columnheader_background token (auto-adapts via CSS var; hex fallback per mode)
  background: `var(--columnheader_background, ${
    theme.palette.mode === 'light' ? '#f0f2f5' : '#242d36'
  })`,
  zIndex: isSticky ? TABLE_Z_INDEX.pinnedHeaderCell : 'auto',
  ...(showShadow &&
    left !== undefined && {
      '&::after': pinnedColumnShadowStyles(theme)
    }),
  ...(showShadow &&
    right !== undefined && {
      '&::before': pinnedColumnShadowStylesLeft(theme)
    })
}))
